export const STATIC_URL = process.env.REACT_APP_STATIC_URL;
